// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".network-status {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: red;\n  color: white;\n  text-align: center;\n  padding: 10px;\n  z-index: 1000;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
